import { Link } from "react-router-dom";
import menuOnClick from "../menuOnClick";

const MFooter = () => {
  return (
    <footer className="z-0 relative w-full h-full px-[calc((100%-var(--container))/2)] bg-[#181818] text-white pb-14 xl:pb-16">
      <div className="relative w-full h-fit max-w-[var(--container-width)] mx-auto py-16">
        <div className=" relative w-fit h-full mx-auto">
          <img
            alt="logo"
            src={"/images/whiteLogo.png"}
            className=" relative w-auto h-full max-h-12 lg:max-h-16 object-contain"
          />
        </div>
        <div className=" relative w-full h-fit flex justify-center items-center gap-3 lg:gap-7 my-10">
          <span
            onClick={() => menuOnClick("#benefits")}
            className="opacity-70 hover:opacity-100"
          >
            <small>회사소개</small>
          </span>
          <small>|</small>
          <span
            onClick={() => menuOnClick("#services")}
            className="opacity-70 hover:opacity-100"
          >
            <small>서비스안내</small>
          </span>
          <small>|</small>
          <span
            onClick={() => menuOnClick("#blog")}
            className="opacity-70 hover:opacity-100"
          >
            <small>작업사례</small>
          </span>
          <small>|</small>
          <span
            onClick={() => menuOnClick("#contact")}
            className="opacity-70 hover:opacity-100"
          >
            <small>문의하기</small>
          </span>
        </div>
        <div className="flex justify-center items-center gap-2 mb-2 lg:mb-0 lg:gap-5 flex-wrap lg:flex-nowrap opacity-90">
          <small className="font-bold">바우하우스</small>
          <small>|</small>
          <small>대표자: 류종훈</small>
          <small>|</small>
          <small>전화: 010-5629-0176</small>
          <small>|</small>
          {/* <small>이메일: </small>
          <small>|</small> */}
          <small>사업자정보: 554-39-01388</small>
        </div>
        <div className="flex justify-center items-center gap-2 lg:gap-5 flex-wrap lg:flex-nowrap opacity-90 mt-3 mb-3">
          {/* <small>|</small> */}
          <small>주소: 대구광역시 수성구 달구벌대로656길 32</small>
        </div>
        <div className="lg:flex justify-center items-center gap-2 text-center lg:text-left opacity-90">
          <small>
            COPYRIGHT ⓒ바우하우스. <br className="block lg:hidden" /> ALL RIGHTS
            RESERVED. DESIGN BY [SMILEEAN]
          </small>
          <br className="block lg:hidden" />
          <Link
            to={"/admin/login"}
            className=" relative w-fit h-fit text-xs py-0.5 px-3 mt-2 lg:mt-0 border rounded-md hover:bg-white hover:text-black"
          >
            <small>관리자</small>
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default MFooter;
